/*
 * Guards the update email route. A hand-off login has no Reporter session, so it is allowed by its pending update
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2026 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ContactEmailService } from 'app/shared/services/contact-email.service';

@Injectable ( {
  providedIn: 'root'
} )
export class UpdateEmailGuard {

  constructor (
    private authGuard: AuthGuard,
    private contactEmailService: ContactEmailService,
  ) {
  }

  canActivate ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): boolean {
    return this.contactEmailService.isHandOff || this.authGuard.canActivate ( route, state );
  }
}
